import React from 'react';
import { Skeleton, Box } from '@mui/material';
import styled from '@emotion/styled';

const SkeletonContainer = styled(Box)({
  padding: '20px 0',
  width: '100%',
});

const SkeletonRow = styled(Box)({
  marginBottom: '20px',
  width: '100%',
});

const LoadingSkeleton: React.FC = () => {
  const renderFormSkeleton = () => (
    <>
      {/* Form Title Skeleton */}
      <SkeletonRow>
        <Skeleton variant="text" width="30%" height={32} />
      </SkeletonRow>

      {/* Input Fields Skeletons */}
      <SkeletonRow>
        <Skeleton variant="text" width="15%" height={24} />
        <Skeleton variant="rounded" width="100%" height={52} />
      </SkeletonRow>

      <SkeletonRow>
        <Skeleton variant="text" width="20%" height={24} />
        <Skeleton variant="rounded" width="100%" height={52} />
      </SkeletonRow>

      <SkeletonRow>
        <Skeleton variant="text" width="18%" height={24} />
        <Skeleton variant="rounded" width="100%" height={100} />
      </SkeletonRow>

      {/* Date Fields */}
      <SkeletonRow>
        <Box sx={{ display: 'flex', gap: '20px' }}>
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="25%" height={24} />
            <Skeleton variant="rounded" width="100%" height={52} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="25%" height={24} />
            <Skeleton variant="rounded" width="100%" height={52} />
          </Box>
        </Box>
      </SkeletonRow>

      {/* Dropdown/Select Field */}
      <SkeletonRow>
        <Skeleton variant="text" width="22%" height={24} />
        <Skeleton variant="rounded" width="100%" height={52} />
      </SkeletonRow>
    </>
  );

  return <SkeletonContainer>{renderFormSkeleton()}</SkeletonContainer>;
};

export default LoadingSkeleton;
